import {
  CostOptimization,
  ExternalProviderKind,
  ExternalProviderMeta,
  OptimizationItem,
  OptimizationItemKind,
  OptimizationOverview,
  ProviderExtras,
} from "@web-app/types";
import http from "@web-app/utils/http";

export type PreviewItemRef = {
  itemId: string;
  kind: OptimizationItemKind;
};

export type PreviewPayload = {
  dspWorkspaceIds: string[];
  externalProviders?: ExternalProviderKind[];
  items: PreviewItemRef[];
  overrides?: Record<string, string>;
  providerExtras?: ProviderExtras;
};

export type PreviewResponse = {
  avgCostPerDrop: number;
  currency: string;
  dspCount: number;
  items: OptimizationItem[];
  totalCost: number;
  totalOrders: number;
};

export type CreateOptimizationPayload = {
  dspWorkspaceIds: string[];
  externalProviders?: ExternalProviderKind[];
  items: PreviewItemRef[];
  name: string;
  overrides?: Record<string, string>;
  providerExtras?: ProviderExtras;
};

export type UpdateOptimizationPayload = {
  dspWorkspaceIds?: string[];
  externalProviders?: ExternalProviderKind[];
  items?: PreviewItemRef[];
  name?: string;
  overrides?: Record<string, string>;
  providerExtras?: ProviderExtras;
};

export type SendItemResult = {
  error?: string;
  itemId: string;
  kind: OptimizationItemKind;
  success: boolean;
};

export type SendResponse = {
  failureCount: number;
  optimization: CostOptimization;
  results: SendItemResult[];
};

export const previewOptimization = (payload: PreviewPayload) =>
  http
    .post<PreviewResponse>("/cost-optimizer/preview", payload)
    .then((response) => response.data);

export const listOptimizations = () =>
  http
    .get<CostOptimization[]>("/cost-optimizer/optimizations")
    .then((response) => response.data);

export const getOptimization = (id: string) =>
  http
    .get<CostOptimization>(`/cost-optimizer/optimizations/${id}`)
    .then((response) => response.data);

export const createOptimization = (payload: CreateOptimizationPayload) =>
  http
    .post<CostOptimization>("/cost-optimizer/optimizations", payload)
    .then((response) => response.data);

export const updateOptimization = (
  id: string,
  payload: UpdateOptimizationPayload,
) =>
  http
    .patch<CostOptimization>(`/cost-optimizer/optimizations/${id}`, payload)
    .then((response) => response.data);

export const sendOptimization = (id: string) =>
  http
    .post<SendResponse>(`/cost-optimizer/optimizations/${id}/send`)
    .then((response) => response.data);

export const getOptimizationOverview = () =>
  http
    .get<OptimizationOverview>("/cost-optimizer/overview")
    .then((response) => response.data);

export const listExternalProviders = () =>
  http
    .get<ExternalProviderMeta[]>("/cost-optimizer/external-providers")
    .then((response) => response.data);
